import React, { useEffect, useState } from 'react';
import { useSpring, animated, config, easings } from '@react-spring/web'

import ImgBoard2 from './img/EmoBoard2.png';
import ImgBoard3 from './img/EmoBoard3.png';
import ImgBoard4 from './img/EmoBoard4.png';
import ImgBoard5 from './img/EmoBoard5.png';
import ImgPin from './img/EmoBoardPin.png';


const col = [
    "#E23E44",
    "#E23E44",
    "#EB9632",
    "#EDBE00",
    "#9CCF40",
    "#17C36B",
    "#17C36B",
];

export function GetMatchCol(qz, match) {


    let resCol = col;

    const per = (match / qz * 100).toFixed(0);

    if (qz < 4) {
        if (qz == 1) { resCol = [col[1], col[5]]; };
        if (qz == 2) { resCol = [col[1], col[3], col[5]]; };
        if (qz == 3) { resCol = [col[1], col[2], col[4], col[5]] };

        return resCol[match];
    }
    else {
        let i = 0;
        if (per > 0) i = 1;
        if (per > 20) i = 2;
        if (per > 40) i = 3;
        if (per > 60) i = 4;
        if (per > 80) i = 5;
        if (per == 100) i = 6;

        return resCol[i];
    }

}



export const GaugeChart = ({ qz, match, type }) => {
    const initrot = -100;
    const [rotation, setRotation] = useState(initrot);
    let [ani, aniSet] = useState(false);

    const grp = type > 1;
    const res = ['꽝이에요.', '안 맞아요.', '그저 그래요.', '아쉬워요.', '좋아요.', '잘 맞아요!', '완벽해요!!'];

    let topTxt = null;
    let imgBoard = ImgBoard5;
    let deg = [-90, -72, -37, 0, 37, 72, 90];
    let resTxt = res;
    let viewDeg;
    let viewTxt;
    let viewCol = GetMatchCol(qz, match);

    const per = ((match / qz) * 100).toFixed(0);
    const sub = `${qz}개 중 ${match}개 일치 (${per}%)`;

    if (type === 0) topTxt = '우리의 궁합은?';
    if (type === 1) topTxt = '우리중 최고의 궁합은?';

    if (qz < 4) {
        if (qz === 1) { imgBoard = ImgBoard2; deg = [-45, 45]; resTxt = [res[1], res[5]]; }
        if (qz === 2) { imgBoard = ImgBoard3; deg = [-62, 0, 62]; resTxt = [res[1], res[3], res[5]]; }
        if (qz === 3) { imgBoard = ImgBoard4; deg = [-72, -25, 25, 72]; resTxt = [res[1], res[2], res[4], res[5]]; }

        viewDeg = deg[match];
        viewTxt = resTxt[match];
    }
    else {
        let i = 0;
        if (per > 0) i = 1;
        if (per > 20) i = 2;
        if (per > 40) i = 3;
        if (per > 60) i = 4;
        if (per > 80) i = 5;
        if (per == 100) i = 6;

        viewDeg = deg[i];
        viewTxt = resTxt[i];
    }


    const aniRot = useSpring({
        transform: ani ? `rotate(${viewDeg}deg)` : `rotate(${initrot}deg)`,
        config: { duration: 1000, easing: easings.easeOutElastic },
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            aniSet(true);
        }, 1000);

        return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 정리
    }, []);

    return (
        <div style={{ width: '100%', borderRadius: '50px', textAlign: 'center' }}>
            <div className={grp ? 'mx-1' : 'mx-5'}>
                {topTxt && <div className='fs-5 my-4'>{topTxt}</div>}

                <div style={{ position: 'relative', width: '100%', paddingBottom: '100%' }}>
                    <img src={imgBoard} alt="Board" style={{ width: '100%', position: 'absolute', top: 0, left: 0 }} />
                    <animated.img src={ImgPin} alt="Pin" style={{ ...aniRot, width: '100%', position: 'absolute', top: 0, left: 0 }} />
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '90%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div style={{ color: viewCol }} className={(grp ? 'fs-3' : 'fs-1') + ' fw-bold'}>{viewTxt}</div>
                        <div className='text-black-50'>{sub}</div>
                    </div>
                </div>
            </div>
            {/* {type < 2 ? (
           
            ) : (
                <div style={{ padding: '10px', borderRadius: '50px' }}>
                    <div style={{ position: 'relative', width: '100%', paddingBottom: '100%' }}>
                        <img src={imgBoard} alt="Board" style={{ width: '100%', position: 'absolute', top: 0, left: 0 }} />
                        <animated.img src={ImgPin} alt="Pin" style={{ ...aniRot, width: '100%', position: 'absolute', top: 0, left: 0 }} />
                        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <div style={{ color: viewCol }} className='fs-3'>{resTxt[match]}</div>
                            <div className='text-black-50 fs-7'>{sub}</div>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
    );
};
